/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 12th 2021, 1:22:30 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { WritableModel } from "lib/schemas/abstract";
import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactValidationSchema,
  ProcessTemplateArtifactSchemaType,
} from "lib/schemas";
import { NumberingSequence } from "lib/schemas/service-builder/NumberingSequence";
import { PrimaryKeyValue, UUID4 } from "lib/types";
import { Many2OneIntPKBaseSchema, Many2ManyUUIDPKBaseSchema, schemaBuilder } from "lib/validation";

export interface BillingConfiguration extends ProcessTemplateArtifact, WritableModel<true> {
  name: string;
  code: string;
  currency: string;
  due_days: number;
  invoice_sequence: PrimaryKeyValue<NumberingSequence> & number;
  html_template?: string;
  payment_methods: UUID4[];
  readonly task_template_count?: number;
  readonly process_template_count?: number;
}

type WriteOnlyBillingConfiguration = Omit<
  BillingConfiguration,
  "id" | "task_template_count" | "process_template_count"
>;

export const BillingConfigurationValidationSchema: ProcessTemplateArtifactSchemaType<WriteOnlyBillingConfiguration> =
  ProcessTemplateArtifactValidationSchema.shape({
    name: schemaBuilder.string().required("Name is required."),
    code: schemaBuilder.string().required("Code is required."),
    currency: schemaBuilder.string().nullable().required("Currency is required."),
    due_days: schemaBuilder.number().required("Due days is required."),
    invoice_sequence: Many2OneIntPKBaseSchema().required(
      "An invoice sequence is required to create a billing configuration"
    ),
    payment_methods: Many2ManyUUIDPKBaseSchema().optional().nullable(), // Null value will mean a manual payment method that will require a payment form configured in payment task.
    html_template: schemaBuilder.string().optional().nullable(),
  });
